import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';

const Checkbox = ({
  label,
  onCheck,
  onChange,
  labelStyle,
  iconStyle,
  style,
  ...props
}) => {
  const handleChange = onCheck ? e => onCheck(e, e.target.checked) : onChange;

  return (
    <FormControlLabel
      style={style}
      control={<MuiCheckbox onChange={handleChange} {...props} />}
      label={labelStyle ? <span style={labelStyle}>{label}</span> : label}
    />
  );
};

export default Checkbox;
